<template>
    <div class="sm:hidden pb-2">
        <div class="pb-1 border-t border-gray-200"></div>

        <div class="pt-1 pb-2 space-y-1">
            <jet-responsive-nav-link
                href="/dashboard"
                :active="route().current() == 'dashboard'"
            >
                <font-awesome-icon
                    :icon="['far', 'comment']"
                    class="text-xl mr-2"
                ></font-awesome-icon>
                Dashboard
            </jet-responsive-nav-link>
        </div>

        <div class="py-1 border-t border-gray-200"></div>

        <div class="pt-1 pb-2 space-y-1">
            <jet-responsive-nav-link
                href="/messages/inbox"
                :active="route().current() == 'messages.inbox'"
            >
                <inbox-icon />
                Inbox
            </jet-responsive-nav-link>
        </div>

        <div class="pt-1 pb-2 space-y-1">
            <jet-responsive-nav-link
                href="/messages/scheduled"
                :active="route().current() == 'md.scheduled'"
            >
                <font-awesome-icon
                    :icon="['far', 'calendar-days']"
                    class="text-xl mr-2"
                ></font-awesome-icon>
                Scheduled
            </jet-responsive-nav-link>
        </div>

        <div class="pt-1 pb-2 space-y-1">
            <jet-responsive-nav-link
                href="/messages/sent"
                :active="route().current() == 'messages.sent'"
            >
                <font-awesome-icon
                    :icon="['far', 'paper-plane']"
                    class="text-xl mr-2"
                ></font-awesome-icon>
                Sent
            </jet-responsive-nav-link>
        </div>

        <div class="pt-1 pb-2 space-y-1">
            <jet-responsive-nav-link
              href="/autoresponder"
              class="text-gray-600"
              :active="route().current() == 'autoresponder.index'"
            >
                <font-awesome-icon
                    :icon="['far', 'message-bot']"
                    class="text-xl mr-2"
                ></font-awesome-icon>
                Autoresponders
            </jet-responsive-nav-link>
        </div>

         <div class="pt-1 pb-2 space-y-1">
            <jet-responsive-nav-link
              href="/template"
              class="text-gray-600"
              :active="route().current() == 'template.index'"
            >
                <font-awesome-icon
                    :icon="['far', 'clipboard-list']"
                    class="text-xl mr-2"
                ></font-awesome-icon>
                Templates
            </jet-responsive-nav-link>
        </div>

        <div class="py-1 border-t border-gray-200"></div>

        <div class="pt-1 pb-2 space-y-1">
            <jet-responsive-nav-link
                href="/contacts"
                :active="route().current() == 'contacts.index'"
            >
                <font-awesome-icon
                    :icon="['far', 'user-group']"
                    class="text-xl mr-2"
                ></font-awesome-icon>
                Contacts
            </jet-responsive-nav-link>
        </div>

        <div class="pt-1 pb-2 space-y-1">
            <jet-responsive-nav-link
                href="/groups"
                :active="route().current() == 'groups.index'"
            >
                <font-awesome-icon
                    :icon="['far', 'screen-users']"
                    class="text-xl mr-2"
                ></font-awesome-icon>
                Lists
            </jet-responsive-nav-link>
        </div>

        <div class="pt-1 pb-2 space-y-1">
          <jet-responsive-nav-link
                href="/keywords"
                :active="route().current() == 'keywords.index'"
              >
                <font-awesome-icon
                  :icon="['far', 'key']"
                  class="text-xl mr-2"
                ></font-awesome-icon>
                Keywords
              </jet-responsive-nav-link>
        </div>

        <div class="py-1 border-t border-gray-200"></div>

        <div class="pt-1 pb-2 space-y-1">
            <jet-responsive-nav-link
                href="/web-forms"
                :active="$page.url.startsWith('/web-forms')"
            >
                <font-awesome-icon
                    :icon="['far', 'rectangle-list']"
                    class="text-xl mr-2"
                ></font-awesome-icon>
                Forms
            </jet-responsive-nav-link>
        </div>

        <div class="pt-1 pb-2 space-y-1">
            <jet-responsive-nav-link
                href="/zapier-integration"
                :active="$page.url.startsWith('/zapier-integration')"
            >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" class="inline-block h-5 w-5 mr-2">
                    <path d="M63.207 26.418H44.432l13.193-13.193c-1.015-1.522-2.03-2.537-3.045-4.06a29.025 29.025 0 0 1-4.059-3.552L37.33 18.807V.54a17.252 17.252 0 0 0-5.074-.507A15.629 15.629 0 0 0 27.18.54v18.775l-13.7-13.7A13.7 13.7 0 0 0 9.42 9.166c-1.015 1.522-2.537 2.537-3.552 4.06L19.06 26.418H.794l-.507 5.074a15.629 15.629 0 0 0 .507 5.074H19.57l-13.7 13.7a27.198 27.198 0 0 0 7.611 7.611l13.193-13.193V63.46a17.252 17.252 0 0 0 5.074.507 15.629 15.629 0 0 0 5.074-.507V44.686L50.014 57.88a13.7 13.7 0 0 0 4.059-3.552 29.025 29.025 0 0 0 3.552-4.059L44.432 37.074h18.775A17.252 17.252 0 0 0 63.715 32a19.028 19.028 0 0 0-.507-5.582zm-23.342 5.074a25.726 25.726 0 0 1-1.015 6.597 15.223 15.223 0 0 1-6.597 1.015 25.726 25.726 0 0 1-6.597-1.015 15.223 15.223 0 0 1-1.015-6.597 25.726 25.726 0 0 1 1.015-6.597 15.223 15.223 0 0 1 6.597-1.015 25.726 25.726 0 0 1 6.597 1.015 29.684 29.684 0 0 1 1.015 6.597z"
                    fill='#A0AEC0'/>
                </svg>
                Zapier <div class="beta-tag text-white text-xs pl-1 pr-1 ml-1 inline-block"
                    :class="{active: $page.url.startsWith('/zapier-integration')}"
                >beta</div>
            </jet-responsive-nav-link>
        </div>

        <!-- Responsive Settings Options -->
        <div class="pt-4 pb-1 border-t border-gray-200">
            <div class="flex items-center px-4">
                <div class="flex-shrink-0">
                    <img
                        class="h-10 w-10 rounded-full"
                        :src="$page.props.auth.user.profile_photo_url"
                        :alt="$page.props.auth.user.name"
                    />
                </div>

                <div class="ml-3">
                    <div class="font-medium text-base text-gray-800">
                        {{ $page.props.auth.user.name }}
                    </div>
                    <div class="font-medium text-sm text-gray-500">
                        {{ $page.props.auth.user.email }}
                    </div>
                </div>
            </div>

            <div class="mt-3 space-y-1">
                <jet-responsive-nav-link
                    href="/user/profile"
                    :active="route().current() == 'profile.show'"
                >
                    Profile
                </jet-responsive-nav-link>

                <jet-responsive-nav-link
                    href="/user/api-tokens"
                    :active="route().current() == 'api-tokens.index'"
                    v-if="$page.props.jetstream.hasApiFeatures"
                >
                    API Tokens
                </jet-responsive-nav-link>
                <jet-responsive-nav-link
                    href="/user/settings"
                >
                    Settings
                </jet-responsive-nav-link>

                <jet-responsive-nav-link
                  href="/user/subscribe"
                  v-if="
                      !$page.props.auth.user
                          .organization
                          .has_active_subscription
                  "
              >
                  Upgrade Account
              </jet-responsive-nav-link>
              <jet-responsive-nav-link
                  href="/user/upgrade"
                  v-if="
                      $page.props.auth.user
                          .organization
                          .has_active_subscription
                  "
              >
                  Upgrade Account
              </jet-responsive-nav-link>
              <jet-responsive-nav-link
                  :href="route('my.subscription')"
                  v-if="$page.props.is_admin && $page.props.auth.user.organization.has_active_subscription"
              >
                My Subscription
              </jet-responsive-nav-link>

                <!-- Authentication -->
                <form method="POST" @submit.prevent="logout">
                    <jet-responsive-nav-link as="button">
                        Logout
                    </jet-responsive-nav-link>
                </form>



                <!-- Team Management -->
                <template
                    v-if="$page.props.jetstream.hasTeamFeatures"
                >
                    <div class="border-t border-gray-200"></div>
                    <div class="block px-4 py-2 text-xs text-gray-400">Manage Team</div>

                    <!-- Team Settings -->
                    <jet-responsive-nav-link
                        :href="'/teams/' + $page.props.auth.user.current_team.id"
                        :active="route().current() == 'teams.show'"
                    >
                        Team Settings
                    </jet-responsive-nav-link>

                    <jet-responsive-nav-link
                        href="/teams/create"
                        :active="route().current() == 'teams.create'"
                    >
                        Create New Team
                    </jet-responsive-nav-link>

                    <div class="border-t border-gray-200"></div>

                    <!-- Team Switcher -->
                    <div class="block px-4 py-2 text-xs text-gray-400">
                        Switch Teams
                    </div>

                    <template v-for="team in $page.props.auth.user.all_teams">
                        <form @submit.prevent="switchToTeam(team)">
                            <jet-responsive-nav-link as="button">
                                <div class="flex items-center">
                                    <svg fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="currentColor" viewBox="0 0 24 24"
                                        v-if="team.id == $page.props.auth.user.current_team_id"
                                        class="mr-2 h-5 w-5 text-green-400"
                                    >
                                        <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                    </svg>
                                    <div>{{ team.name }}</div>
                                </div>
                            </jet-responsive-nav-link>
                        </form>
                    </template>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import JetResponsiveNavLink from "../../Jetstream/ResponsiveNavLink";

    import InboxIcon from '../InboxIcon';
    
    export default {
        components: {
            JetResponsiveNavLink, InboxIcon
        },
        methods: {
            switchToTeam(team) {
                this.$inertia.put(
                    "/current-team",
                    {
                        team_id: team.id
                    },
                    {
                        preserveState: false
                    }
                );
            },
            logout() {
                axios.post("/logout").then(response => {
                    window.location = "/";
                });
            }
        }
    }
</script>
